import moment from 'moment'
import { Fuzzy } from '@utils/fuse-search'
import type { SubmittedBy } from './contexts/approvalContext/types'
import type { Submission } from '@global/types'

export function getRequestsWithinDateRange({
  requests,
  start,
  end,
}: {
  requests: Submission[]
  start: moment.Moment | null
  end: moment.Moment | null
}): Submission[] {
  return requests.filter(submission => {
    const createdAt = moment(submission.created_at).startOf('day')
    const isSameOrBeforeEnd = createdAt.isSameOrBefore(end)

    if (start) {
      const isSameOrAfterStart = createdAt.isSameOrAfter(start)
      return isSameOrAfterStart && isSameOrBeforeEnd
    }

    return isSameOrBeforeEnd
  })
}

export function createSubmittedByOptions(requests: Submission[]): SubmittedBy[] {
  const createdByToUserIdMap = {}

  requests.forEach(request => {
    if (request.created_by && !createdByToUserIdMap[request.created_by]) {
      createdByToUserIdMap[request.created_by] = request.user_id ?? request.created_by
    }
  })

  const uniqeSubmitterNames = Object.keys(createdByToUserIdMap)

  const submitters: SubmittedBy[] = uniqeSubmitterNames.map(name => ({
    value: createdByToUserIdMap[name],
    label: name,
  }))

  return submitters
}

export function fuzzySearch(label: string, requests: Submission[]): Submission[] {
  const fuzzy = new Fuzzy(requests, { keys: ['created_by'] })
  return fuzzy.search(label)
}
